export default __webpack_public_path__ + "static/media/img2.ef5f0f58.png";